
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Observable } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { MatSort, Sort } from "@angular/material/sort";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { Router } from "@angular/router";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
import { DateAdapter } from "@angular/material/core";
import { UserModel } from "app/_models/user-model";
import { TsiProject } from "app/_models/tsi-project";
import { CrudInvProjectService } from "app/_services/MasterCrudOps/crud-inv-project.service";
import { AddInvProjectComponent } from "./add-inv-project/add-inv-project.component";
import { EditInvProjectComponent } from "./edit-inv-project/edit-inv-project.component";
declare const swal: any;

@Component({
  selector: 'app-inv-projects',
  templateUrl: './inv-projects.component.html',
  styleUrls: ['./inv-projects.component.css']
})
export class InvProjectsComponent implements OnInit {
  currentUser: UserModel;
  projects: TsiProject[];
  totalresultDetails: TsiProject[];
  isAdminGroupUser: boolean = false;
  displayedColumns: string[] = [
    "icon",
    "projectName",
    "description",
    "isDeleted",
    "edit",
    "delete",
  ];
  dataSource = new MatTableDataSource<TsiProject>([]);
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (this.dataSource != null) {
      this.dataSource.sort = value;
    }
  }
  isLoaderResult = true;
  resultLength = 0;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  editProject: TsiProject;
  pageEvent: PageEvent;

  constructor(
    public datepipe: DatePipe,
    private dateAdapter: DateAdapter<Date>,
    private _liveAnnouncer: LiveAnnouncer,
    private matDialog: MatDialog,
    private crudInvProject:CrudInvProjectService,
    private router: Router
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit(): void {
    this.isLoaderResult = true;
    this.dataSource = null; 
    this.projects = null;
    this.pageSize  = 25;
    this.getAllProjects(1, this.pageSize, false);
    this.isLoaderResult = false;
  }
  ngAfterViewInit() {
    if (this.dataSource != null) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  openDialog() {
    const dialogRef = this.matDialog.open(AddInvProjectComponent, {
      width: "800px",
      disableClose: false,
      data: {pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status )
      {
        this.getAllProjects(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
  }

  updateProject(e, element): void {
    this.editProject = JSON.parse(JSON.stringify(element));;
    const dialogRef = this.matDialog.open(EditInvProjectComponent, {
      width: "800px",
      disableClose: true,
      data: {  project:this.editProject,   pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAllProjects(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
  }
   

  softDelete(e, element) {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Delete IT!",
    }).then((result) => {
      if (result === true) {
        this.deleteProject(e, element);
      }
    });
  }

  deleteProject(e, element): void {
    this.isLoaderResult = true;
    this.crudInvProject.deleteInvProject(element.invProjectId).subscribe((data) => {
      if (data.didError) {
        swal({
          title: "",
          text: data.message + "\n" + data.additionalMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      } else {
        swal({
          title: "",
          text: data.message,
          type: "success",
          confirmButtonClass: "btn btn-info",
        });
        this.getAllProjects((this.paginator.pageIndex+1), this.paginator.pageSize, false);
      }
      
    },
    (error) => {
      const errorMessage =  error.error?.title || error.error ||'Something went wrong. Please contact admin.'; 
      swal({
        title: '',
        text: errorMessage,
        type: 'error',
        confirmButtonClass: 'btn btn-info'
      });
    }
  );
    this.isLoaderResult = false;
  }

  getAllProjects(pageNumber: Number, currPageSize: Number, hasDownloadAllData:boolean) {
    let model = {
      currentPage: pageNumber,
      pageSize: currPageSize,
      downloadAllData: hasDownloadAllData,
      yesNoAll:1
    } ;
    this.crudInvProject.getPagedInvProjects(model)
    .subscribe((data) => {
      this.isLoaderResult = false;
      if (!data.didError) {
        this.projects = data.model;
        this.dataSource = new MatTableDataSource<TsiProject>(
          this.projects
        );
        this.totalRows = data.totalRecords;
        this.resultLength = this.projects.length;
      } else {
        this.projects = data.model;
        swal({
          title: "",
          text: data.message,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    },
    (error) => {
      this.isLoaderResult = false;
      swal({
        title: "",
        text: "Somthing went wrong. Please contact admin",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    }
  );
}

  /*
  exportExcel() {
    const workSheet = XLSX.utils.json_to_sheet(
      this.dataSource.data.map((item) => {
        return { Brand: item.projectName, Description: item.description, IsDeleted: item.isDeleted};
      })
    );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
    var fileName =
      "TsiProjects_" +
      this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
      ".xlsx";
    XLSX.writeFile(workBook, fileName);
  }*/

  downloadAllRecords()
  {
    swal({
      title: "Are you sure to do this?",
      text: "This process does not display data. It will download all records in a spreadsheet.",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Download the records.",
    }).then((result) => {
      if (result === true) {
        this.isLoaderResult = true;
        let model = {
          currentPage:0,
          pageSize:0,
          downloadAllData:true,
          yesNoAll: 1
        };
       this.crudInvProject.getPagedInvProjects(model)
           .subscribe(
                    (results) => {
          this.isLoaderResult = false;
          if (!results.didError) {
            this.totalresultDetails = results.model;
            const workSheet = XLSX.utils.json_to_sheet(
              this.totalresultDetails.map((item) => {
                return {
                  Project: item.projectName, 
                  Description: item.description, 
                  IsDeleted: item.isDeleted
                };
              })
            );
            const workBook: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
            var fileName =
                        "TsiProjects_" +
                        this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
                        ".xlsx";
            XLSX.writeFile(workBook, fileName);
          } else {
            this.isLoaderResult = false;
            swal({
              title: "",
              text: results.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        },
        (error) => {
          this.isLoaderResult = false;
          swal({
            title: "",
            text: "Somthing went wrong. Please contact admin",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAllProjects((this.paginator.pageIndex+1), this.paginator.pageSize, false);
  }
}
